var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearSkyDay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5127_30996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 12C17.5 8.96243 15.0376 6.5 12 6.5C8.96243 6.5 6.5 8.96243 6.5 12C6.5 15.0376 8.96243 17.5 12 17.5V19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19V17.5C15.0376 17.5 17.5 15.0376 17.5 12Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 23V21C11.25 20.5858 11.5858 20.25 12 20.25C12.4142 20.25 12.75 20.5858 12.75 21V23C12.75 23.4142 12.4142 23.75 12 23.75C11.5858 23.75 11.25 23.4142 11.25 23Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 3V1C11.25 0.585786 11.5858 0.25 12 0.25C12.4142 0.25 12.75 0.585786 12.75 1V3C12.75 3.41421 12.4142 3.75 12 3.75C11.5858 3.75 11.25 3.41421 11.25 3Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 11.25H3C3.41421 11.25 3.75 11.5858 3.75 12C3.75 12.4142 3.41421 12.75 3 12.75H1C0.585786 12.75 0.25 12.4142 0.25 12C0.25 11.5858 0.585786 11.25 1 11.25Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 11.25H23C23.4142 11.25 23.75 11.5858 23.75 12C23.75 12.4142 23.4142 12.75 23 12.75H21C20.5858 12.75 20.25 12.4142 20.25 12C20.25 11.5858 20.5858 11.25 21 11.25Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75215 3.6915L6.16636 5.10571C6.45926 5.3986 6.45926 5.87348 6.16636 6.16637C5.87347 6.45926 5.39859 6.45926 5.1057 6.16637L3.69149 4.75216C3.39859 4.45926 3.39859 3.98439 3.69149 3.6915C3.98438 3.3986 4.45925 3.3986 4.75215 3.6915Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8943 17.8336L20.3085 19.2478C20.6014 19.5407 20.6014 20.0156 20.3085 20.3085C20.0156 20.6014 19.5407 20.6014 19.2478 20.3085L17.8336 18.8943C17.5407 18.6014 17.5407 18.1265 17.8336 17.8336C18.1265 17.5407 18.6014 17.5407 18.8943 17.8336Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3085 4.75215L18.8943 6.16637C18.6014 6.45926 18.1265 6.45926 17.8336 6.16637C17.5407 5.87347 17.5407 5.3986 17.8336 5.10571L19.2478 3.69149C19.5407 3.3986 20.0156 3.3986 20.3085 3.69149C20.6014 3.98439 20.6014 4.45926 20.3085 4.75215Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16636 18.8943L4.75215 20.3085C4.45925 20.6014 3.98438 20.6014 3.69149 20.3085C3.39859 20.0156 3.39859 19.5407 3.69149 19.2478L5.1057 17.8336C5.39859 17.5407 5.87347 17.5407 6.16636 17.8336C6.45925 18.1265 6.45925 18.6014 6.16636 18.8943Z",
    fill: "#263238"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5127_30996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearSkyDay);
export default __webpack_public_path__ + "static/media/ClearSkyDay.8312a0bbc0e25714a521eb4a104ee0c8.svg";
export { ForwardRef as ReactComponent };